import { getThirdwebBaseUrl } from "../../../../../utils/domains.js";
import { getLoginUrl } from "../../../core/authentication/getLoginPath.js";
import { DEFAULT_POP_UP_SIZE } from "./constants.js";
const closeWindow = ({ isWindowOpenedByFn, win, closeOpenedWindow, }) => {
    if (isWindowOpenedByFn) {
        win?.close();
    }
    else {
        if (win && closeOpenedWindow) {
            closeOpenedWindow(win);
        }
        else if (win) {
            win.close();
        }
    }
};
export const loginWithOauthRedirect = (options) => {
    const loginUrl = getLoginUrl({
        ...options,
        mode: options.mode || "redirect",
    });
    if (options.mode === "redirect") {
        window.location.href = loginUrl;
    }
    else {
        window.open(loginUrl);
    }
};
export const loginWithOauth = async (options) => {
    let win = options.openedWindow;
    let isWindowOpenedByFn = false;
    if (!win) {
        win = window.open(getLoginUrl({ ...options, mode: "popup" }), `Login to ${options.authOption}`, DEFAULT_POP_UP_SIZE);
        isWindowOpenedByFn = true;
    }
    if (!win) {
        throw new Error("Something went wrong opening pop-up");
    }
    const result = await new Promise((resolve, reject) => {
        // detect when the user closes the login window
        const pollTimer = window.setInterval(async () => {
            if (win.closed) {
                clearInterval(pollTimer);
                window.removeEventListener("message", messageListener);
                reject(new Error("User closed login window"));
            }
        }, 1000);
        const messageListener = async (event) => {
            if (event.origin !== getThirdwebBaseUrl("inAppWallet")) {
                return;
            }
            if (typeof event.data !== "object") {
                reject(new Error("Invalid event data"));
                return;
            }
            switch (event.data.eventType) {
                case "oauthSuccessResult": {
                    window.removeEventListener("message", messageListener);
                    clearInterval(pollTimer);
                    closeWindow({
                        isWindowOpenedByFn,
                        win,
                        closeOpenedWindow: options.closeOpenedWindow,
                    });
                    if (event.data.authResult) {
                        resolve(event.data.authResult);
                    }
                    break;
                }
                case "oauthFailureResult": {
                    window.removeEventListener("message", messageListener);
                    clearInterval(pollTimer);
                    closeWindow({
                        isWindowOpenedByFn,
                        win,
                        closeOpenedWindow: options.closeOpenedWindow,
                    });
                    reject(new Error(event.data.errorString));
                    break;
                }
                default: {
                    // no-op, DO NOT THROW HERE
                }
            }
        };
        window.addEventListener("message", messageListener);
    });
    return result;
};
//# sourceMappingURL=oauth.js.map